import type { Server, VirtualMachine, CloudPC } from './types';

export const mockServers: Server[] = [
  {
    id: '1',
    datacenter: '北京数据中心',
    serverNumber: 'BJ-SRV-001',
    serverAlias: '北京主机01',
    status: 'normal',
    cpu: { available: 32, total: 64, model: 'Intel Xeon Gold 6248R' },
    memory: { available: 128, total: 256 },
    disk: { available: 2000, total: 4000, type: 'SSD' },
    gpu: { available: 2, total: 4, model: 'NVIDIA Tesla T4' },
  },
  {
    id: '2',
    datacenter: '北京数据中心',
    serverNumber: 'BJ-SRV-002',
    serverAlias: '北京主机02',
    status: 'normal',
    cpu: { available: 48, total: 96, model: 'AMD EPYC 7763' },
    memory: { available: 256, total: 512 },
    disk: { available: 3500, total: 8000, type: 'NVMe SSD' },
    gpu: { available: 4, total: 8, model: 'NVIDIA RTX 5070' },
  },
  {
    id: '3',
    datacenter: '上海数据中心',
    serverNumber: 'SH-SRV-001',
    serverAlias: '上海主机01',
    status: 'normal',
    cpu: { available: 24, total: 64, model: 'Intel Xeon Platinum 8358' },
    memory: { available: 192, total: 384 },
    disk: { available: 4500, total: 10000, type: 'NVMe SSD' },
    gpu: { available: 6, total: 8, model: 'NVIDIA RTX 5090 16G' },
  },
  {
    id: '4',
    datacenter: '上海数据中心',
    serverNumber: 'SH-SRV-002',
    serverAlias: '上海主机02',
    status: 'disabled',
    cpu: { available: 64, total: 64, model: 'AMD EPYC 7713' },
    memory: { available: 512, total: 512 },
    disk: { available: 8000, total: 8000, type: 'SSD' },
    gpu: { available: 4, total: 4, model: 'NVIDIA Tesla T4' },
  },
  {
    id: '5',
    datacenter: '深圳数据中心',
    serverNumber: 'SZ-SRV-001',
    serverAlias: '深圳主机01',
    status: 'normal',
    cpu: { available: 16, total: 128, model: 'Intel Xeon Platinum 8380' },
    memory: { available: 128, total: 1024 },
    disk: { available: 5000, total: 20000, type: 'NVMe SSD' },
    gpu: { available: 8, total: 16, model: 'NVIDIA RTX 5090 32G' },
  },
];

export const mockVirtualMachines: VirtualMachine[] = [
  {
    id: 'VM-001',
    name: '虚拟机-001',
    status: 'normal',
    cpu: { cores: 8, model: 'Intel Xeon Gold 6248R' },
    memory: { capacity: 32 },
    systemDisk: { capacity: 500, type: 'SSD' },
    gpu: { count: 1, model: 'NVIDIA Tesla T4' },
  },
  {
    id: 'VM-002',
    name: '虚拟机-002',
    status: 'normal',
    cpu: { cores: 16, model: 'Intel Xeon Gold 6248R' },
    memory: { capacity: 64 },
    systemDisk: { capacity: 1000, type: 'SSD' },
    gpu: { count: 2, model: 'NVIDIA Tesla T4' },
  },
  {
    id: 'VM-003',
    name: '虚拟机-003',
    status: 'disabled',
    cpu: { cores: 4, model: 'Intel Xeon Gold 6248R' },
    memory: { capacity: 16 },
    systemDisk: { capacity: 250, type: 'SSD' },
    gpu: { count: 0, model: '-' },
  },
];

export const mockCloudPCs: CloudPC[] = [
  {
    id: 'CPC-1001',
    name: '云电脑-开发环境01',
    user: { username: '张伟', phone: '13800138001' },
    config: '8核/32G/500G SSD/Tesla T4',
    createTime: '2024-01-15 09:30:00',
    runningTime: '15天8小时',
    vmId: 'VM-001',
  },
  {
    id: 'CPC-1002',
    name: '云电脑-设计工作站',
    user: { username: '李娜', phone: '13800138002' },
    config: '16核/64G/1T SSD/RTX 5070',
    createTime: '2024-01-20 14:20:00',
    runningTime: '10天5小时',
    vmId: 'VM-002',
  },
  {
    id: 'CPC-1003',
    name: '云电脑-测试环境',
    user: { username: '王芳', phone: '13800138003' },
    config: '4核/16G/250G SSD',
    createTime: '2024-01-25 10:15:00',
    runningTime: '5天12小时',
  },
  {
    id: 'CPC-1004',
    name: '云电脑-AI训练01',
    user: { username: '刘强', phone: '13800138004' },
    config: '32核/128G/2T NVMe/RTX 5090 32G',
    createTime: '2024-01-28 16:45:00',
    runningTime: '2天18小时',
  },
];
